
<template>
	<div class="full-service">
		<v-e24-nav-bar/>
		<imageShort/>
		<content2Columns />
		<iconBar/>
		<content2ColumnsFull/>
		<v-e24-footer :build="build"/>
	</div>
</template>

<script>
import imageShort from '@/components/full/headerImageShort'
import content2Columns from '@/components/full/content2Columns'
import iconBar from '@/components/full/iconsBar'
import content2ColumnsFull from '@/components/full/content2columnsFull'
import readBuild from '../util/readBuild'

export default {
	name: 'fullService',
	components: {
		imageShort,
		content2Columns,
		iconBar,
		content2ColumnsFull
	},
	data () {
		return {
			build: ''
		}
	},
	mixins: [readBuild],
	mounted () {
		this.build = this.getBuild()
		this.$nextTick(() => {
			document.title = 'Hire us: Title 24 consultant for your energy compliance needs'
		})
	}
}
</script>



// WEBPACK FOOTER //
// src/views/FullService.vue